if (!customElements.get('store-locator')) {
  class StoreLocator extends HTMLElement {
    constructor() {
      super();
      this.handleScroll = this.handleScroll.bind(this);
      this.scrollLocked = false;
      this._scrollLockTimer = null;
      this.isSticky = false;
      this._tabsNaturalTop = null;
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.store-locator__tab'));
      this.countries = this.tabs.map(tab => document.getElementById(tab.dataset.country));

      if (!this.tabs.length || !this.countries.some(Boolean)) return;

      this.tabsEl = this.querySelector('.scroll-nav');

      if (theme?.utils?.initDragScroll) {
        this._dragScroll = theme.utils.initDragScroll(this.tabsEl);
      }

      this.spacer = document.createElement('div');
      this.tabsEl.insertAdjacentElement('afterend', this.spacer);

      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', (e) => this.handleTabClick(e, i));
      });

      this.setActive(0);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      this.handleScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      clearTimeout(this._scrollLockTimer);
      if (this.spacer) this.spacer.remove();
      if (this._dragScroll) {
        this._dragScroll.destroy();
        this._dragScroll = null;
      }
    }

    getHeaderHeight() {
      const header = document.querySelector('.header-section');
      if (!header) return 0;
      const bottom = header.getBoundingClientRect().bottom;
      return bottom > 0 ? bottom : 0;
    }

    handleScroll() {
      const headerH = this.getHeaderHeight();

      if (!this.isSticky) {
        this._tabsNaturalTop = this.tabsEl.getBoundingClientRect().top + window.scrollY;
      }

      const shouldStick = window.scrollY + headerH >= this._tabsNaturalTop;

      if (shouldStick !== this.isSticky) {
        this.isSticky = shouldStick;
        if (shouldStick) {
          this.spacer.style.height = this.tabsEl.offsetHeight + 'px';
          this.tabsEl.classList.add('scroll-nav--sticky');
        } else {
          this.spacer.style.height = '0';
          this.tabsEl.classList.remove('scroll-nav--sticky');
          this.tabsEl.style.top = '';
        }
      }

      if (this.isSticky) {
        this.tabsEl.style.top = headerH + 'px';
      }

      if (!this.scrollLocked) {
        const threshold = headerH + this.tabsEl.offsetHeight + 16;
        let activeIndex = 0;
        this.countries.forEach((country, i) => {
          if (country && country.getBoundingClientRect().top <= threshold) {
            activeIndex = i;
          }
        });
        this.setActive(activeIndex);
      }
    }

    handleTabClick(e, index) {
      const country = this.countries[index];
      if (!country) return;
      this.setActive(index);
      this.scrollLocked = true;
      const offset = this.getHeaderHeight() + this.tabsEl.offsetHeight + 16;
      const targetY = country.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: targetY, behavior: 'smooth' });
      clearTimeout(this._scrollLockTimer);
      this._scrollLockTimer = setTimeout(() => { this.scrollLocked = false; }, 1000);
    }

    setActive(index) {
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('is-active', i === index);
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }
  }

  customElements.define('store-locator', StoreLocator);
}
